import styled from 'styled-components';

import { colorSchemeConfig } from '@rebound/design-system/theme/colorScheme';

const LinkItem = styled.div<{ scheme: string }>`
  color: ${(props) =>
    colorSchemeConfig[props.scheme]
      ? colorSchemeConfig[props.scheme].v600
      : ''};

  &:hover {
    color: ${(props) =>
      colorSchemeConfig[props.scheme]
        ? colorSchemeConfig[props.scheme].v600
        : ''};
  }
`;

export default LinkItem;
